<template>
  <div class="hb">
    <div class="top">
      <img :src="topImg" alt="" />
    </div>
    <p class="tip">
      当前报名人数已满，请您填写联系方式，如有人员因故无法前来，工作人员会与您取得联系收集详细信息，谢谢
    </p>
    <van-field
      v-model="name"
      name="姓名"
      required
      label="姓名"
      placeholder="请输入姓名"
      :rules="[{ required: true, message: '请填写用户名' }]"
    />
    <van-field
      v-model="phoneNumber"
      name="联系电话"
      required
      label="联系电话"
      placeholder="请输入联系电话"
      :rules="[{ required: true, message: '请填写联系电话' }]"
    />
    <div class="button">
      <van-button
        type="info"
        :loading="false"
        loading-text="提交中"
        @click="submitSign"
      >
        确认报名
      </van-button>
      <van-button type="default" @click="showSchedule"> 会议日程 </van-button>
    </div>

    <div class="bottom">
      <img :src="bottomImg" alt="" />
    </div>
  </div>
</template>

<script>
import { submitForm } from "../api/api";

export default {
  data() {
    return {
      topImg: require("@/assets/top.png"),
      bottomImg: require("@/assets/bottom.png"),
      name: "",
      phoneNumber: "",
    };
  },
  methods: {
    submitSign() {
      if (this.name && this.phoneNumber) {
        submitForm({ name: this.name, phoneNumber: this.phoneNumber }).then(
          (res) => {
            console.log(res);
            this.$router.push({ path: "/success" });
          }
        );
      } else {
        // Toast("");
        this.$toast("请将将信息填写完整");
      }
    },
    showSchedule() {
      this.$router.push({ path: "/home" });
    },
  },
};
</script>
<style lang="less" scoped>
.hb {
  width: 100vw;
  height: 100vh;
  position: relative;
  .top {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .tip {
    padding: 0 20px;
    line-height: 27px;
    margin-bottom: 20px;
    font-size: 17px;
  }
  .button {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    position: relative;
    z-index: 99;
    /deep/ .van-button {
      background-image: linear-gradient(to right, #50b1f8, #3171cf);
    }
    /deep/ .van-button + .van-button {
      margin-left: 30px;
      color: white;
      background-image: linear-gradient(to right, #50b1f8, #3171cf);
    }
  }
  .bottom {
    width: 100%;
    img {
      width: 100%;
    }
    position: absolute;
    bottom: 0;
  }
}
</style>
